import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextCallout2, TextCallout1, IconClose } from 'blocket-ui'
import { Link } from 'react-router-dom'
import { mediaQueries } from '@blazar-plugins/device'
import Cookies from 'universal-cookie'
import Modal from './OnboardingModal'
import { Package, PackageSmall } from './package.svg.js'
import { Payment } from './payment.svg.js'

/* Onboarding */
const Shipping = styled.div`
  background: rgb(240, 245, 251);
  border-radius: 0px;
  border-top: 1px solid rgb(223, 222, 222);
  border-bottom: 1px solid rgb(223, 222, 222);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;
  @media ${mediaQueries.medium} {
    border: 1px solid rgb(223, 222, 222);
    max-height: 110px;
    margin-top: 30px;
    margin-bottom: 10px;
  }
`

const TitleWrapper = styled.div`
  margin-bottom: 5px;
  display: flex;
  align-items: center;
`

const Button = styled(TextCallout1)`
  background: rgb(65, 130, 195);
  border-radius: 100px;
  padding: 0 10px;
  color: #fff;
  text-transform: uppercase;
  margin-left: 8px;
  box-shadow: 0px 1px 0px 0px rgb(51, 97, 148);
  font-size: 12px;
  display: none;
  @media ${mediaQueries.medium} {
    display: block;
  }
`

const Title = styled(TextCallout1)`
  font-size: 17px;
  color: rgb(90, 87, 85);
`

const Text = styled(TextCallout2)`
  font-size: 15px;
  margin-bottom: 10px;
  color: rgb(54, 52, 51);
`

const Readmore = styled(Link)`
  font-size: 15px;
  font-weight: 500;
  color: rgb(65, 130, 195);
`

const Close = styled(IconClose)`
  color: '#363332';
  width: 18px;
  cursor: pointer;
`

const CloseButton = styled.button`
  width: auto;
`

const Wrapper = styled.div`
  &.onBoardingInfoWrapper {
    margin-right: 30px;
    @media ${mediaQueries.medium} {
      margin-right: 60px;
    }
  }
  &.onBoardingPackageWrapper {
    flex: 1;
    svg:nth-of-type(1) {
      display: none;
    }
    @media ${mediaQueries.medium} {
      svg:nth-of-type(1) {
        display: block;
      }
      svg:nth-of-type(2) {
        display: none;
      }
    }
  }
`

const cookies = new Cookies()

export const OnboardingBanner = ({
  title,
  btnText,
  readmoreText,
  readmoreUrl,
  text,
  cookieKey,
  isPayment,
}) => {
  const [onBoardingShows, setOnBoardingShows] = useState(false)
  const [onBoardingModalShow, setOnBoardingModalShow] = useState(false)

  const paymentStyle = { marginBottom: '-9px' }
  const paymentSmallStyle = { marginBottom: '-50px' }

  /* Cookie */
  const setHideShippingOnboarding = (value) => {
    cookies.set(cookieKey, value, {
      path: '/',
      maxAge: 3153600000, // 60 * 60 * 24 * 365 * 100,
      httpOnly: false,
    })
  }

  useEffect(() => {
    const getShippingCookie = () => cookies.get(cookieKey)
    const showOnBoarding = getShippingCookie(cookieKey) !== 'true'
    setOnBoardingShows(showOnBoarding)
  }, [cookieKey])

  const onOnBoardingClose = () => {
    setOnBoardingShows(false)
    setHideShippingOnboarding(true)
  }

  const onOnBoardingLinkClick = (e) => {
    e.preventDefault()
    if (readmoreUrl) {
      window.location.href = readmoreUrl
    } else {
      setOnBoardingModalShow(true)
    }
  }

  return (
    onBoardingShows && (
      <>
        <Shipping>
          <Wrapper className="onBoardingInfoWrapper">
            <TitleWrapper>
              <Title>{title}</Title>
              <Button>{btnText}</Button>
            </TitleWrapper>
            <Text>{text}</Text>
            {readmoreText && (
              <Readmore title={readmoreText} to="" onClick={onOnBoardingLinkClick}>
                {readmoreText}
              </Readmore>
            )}
          </Wrapper>
          <Wrapper className="onBoardingPackageWrapper">
            {!isPayment && (
              <>
                <Package />
                <PackageSmall />
              </>
            )}
            {isPayment && (
              <>
                <Payment style={paymentStyle} />
                <Payment style={paymentSmallStyle} />
              </>
            )}
          </Wrapper>
          <CloseButton
            type="button"
            aria-label="Stäng onboarding banner"
            onClick={onOnBoardingClose}
          >
            <Close />
          </CloseButton>
        </Shipping>
        <Modal
          onClose={() => {
            setOnBoardingModalShow(false)
          }}
          active={onBoardingModalShow}
        />
      </>
    )
  )
}

OnboardingBanner.propTypes = {
  title: PropTypes.string,
  btnText: PropTypes.string,
  readmoreText: PropTypes.string,
  readmoreUrl: PropTypes.string,
  text: PropTypes.string,
  cookieKey: PropTypes.string,
  isPayment: PropTypes.bool,
}

OnboardingBanner.defaultProps = {
  title: 'Köp prylar som kan skickas!',
  btnText: 'Nyhet',
  isPayment: false,
  readmoreText: 'Läs mer om det nya filtret',
  text: 'Nu kan du filtrera på frakt och handla tryggt från hela Sverige.',
  cookieKey: 'hideShippingOnboarding',
}
